import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Box, Button, Checkbox, Column, Popover } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { ALLOWED_DRAFTS_AI_SEARCH_STATUS } from '~/types/api/drafts-search';
import { FilterChip } from '../FilterChip/FilterChip';
import { isExcludeMode, localizeStatus, valueLabelFor } from './StatusChip.utils';
export const GetStatusChipTID = (parentTestId)=>getTestIds(parentTestId);
export const StatusChip = (param)=>{
    let { testId, predicate, onChange } = param;
    var _predicate_nin, _predicate_in;
    const { StatusChipTestIds } = useMemo(()=>GetStatusChipTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    const [anchorEl, setAnchorEl] = useState(null);
    const isExclude = isExcludeMode(predicate);
    const initialValues = isExclude ? (_predicate_nin = predicate.nin) !== null && _predicate_nin !== void 0 ? _predicate_nin : [] : (_predicate_in = predicate.in) !== null && _predicate_in !== void 0 ? _predicate_in : [];
    const [draftValues, setDraftValues] = useState(initialValues);
    const openPopover = (event)=>{
        setDraftValues(initialValues);
        setAnchorEl(event.currentTarget);
    };
    const closePopover = ()=>setAnchorEl(null);
    const toggleOption = (status)=>{
        setDraftValues((current)=>current.includes(status) ? current.filter((s)=>s !== status) : [
                ...current,
                status
            ]);
    };
    const toggleOperator = ()=>{
        onChange(isExclude ? {
            in: predicate.nin
        } : {
            nin: predicate.in
        });
    };
    const apply = ()=>{
        if (draftValues.length === 0) {
            onChange(undefined);
        } else {
            onChange(isExclude ? {
                nin: draftValues
            } : {
                in: draftValues
            });
        }
        closePopover();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FilterChip, {
                testId: testId,
                fieldLabel: t.statusLabel(),
                operator: {
                    label: isExclude ? t.operatorIsNot() : t.operatorIs(),
                    onToggle: toggleOperator,
                    biName: 'drafts_ai_search_chip_toggle_status_operator'
                },
                valueLabel: valueLabelFor(predicate, t),
                onValueClick: openPopover,
                onRemove: ()=>onChange(undefined),
                removeBiName: "drafts_ai_search_chip_remove_status"
            }),
            /*#__PURE__*/ _jsx(Popover, {
                testId: StatusChipTestIds.EditPopover(),
                open: anchorEl != null,
                anchorEl: anchorEl,
                onClose: closePopover,
                children: /*#__PURE__*/ _jsx(Box, {
                    padding: 12,
                    children: /*#__PURE__*/ _jsxs(Column, {
                        gap: 8,
                        children: [
                            ALLOWED_DRAFTS_AI_SEARCH_STATUS.map((status)=>/*#__PURE__*/ _jsx(Checkbox, {
                                    testId: StatusChipTestIds.Option(status),
                                    bi: {
                                        name: "drafts_ai_search_chip_status_".concat(status)
                                    },
                                    checked: draftValues.includes(status),
                                    onChange: ()=>toggleOption(status),
                                    children: localizeStatus(status, t)
                                }, status)),
                            /*#__PURE__*/ _jsx(Button, {
                                testId: StatusChipTestIds.ApplyButton(),
                                bi: {
                                    name: 'drafts_ai_search_chip_apply_status'
                                },
                                onClick: apply,
                                children: t.applyButton()
                            })
                        ]
                    })
                })
            })
        ]
    });
};
